import styled from '@emotion/styled'

export const TransactionsSearchWrapper = styled.div`
  flex-grow: 1;
  position: relative;
`
